module.exports = __webpack_public_path__ + "img/farming_6.a3264f5a.png";